import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useUpdatePageBookmark } from "../../../api/mutations";
import { BookmarkI, BookmarkTypeEnum } from "../../../types";
import { useUpdateToolboxByTopicId } from "../../../api/mutations";
import { analytics } from "../../../services/AnalyticsService";
import FavoritesListGrouped from "./FavoritesListGrouped";

export const SkillsTab = ({
  topicId,
  toolboxId,
}: {
  topicId: string;
  toolboxId?: string;
}) => {
  const queryClient = useQueryClient();

  const { mutate: updateToolbox } = useUpdateToolboxByTopicId({
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["toolbox"] });
    },
  });

  React.useEffect(() => {
    if (topicId) {
      updateToolbox({
        moduleId: topicId,
        body: {
          skillsReadAt: new Date(),
        },
      });
    }
  }, [topicId]);

  const { mutate: updateBookmark } = useUpdatePageBookmark({
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["bookmarks", BookmarkTypeEnum.PAGE],
      });
    },
  });
  const onClickSkill = (bookmark: BookmarkI) => {
    // Track skill clicked analytics (page opened from toolbox)
    if (toolboxId) {
      analytics.track("toolbox_skill_opened", {
        category: "Toolbox",
        elementId: toolboxId,
        additionalDetails: {
          moduleId: topicId,
          lessonId: bookmark.lesson?._id,
          pageId: bookmark.page?._id,
          bookmarkId: bookmark._id,
        },
      });
    }

    updateBookmark({
      _id: bookmark._id,
      page: bookmark.page?._id,
      lesson: bookmark.lesson?._id,
      module: bookmark.module?._id,
      type: BookmarkTypeEnum.PAGE,
      lastActive: new Date(),
    });
  };

  return (
    <div className="flex flex-col h-full w-full">
      <div className="mx-auto w-full sm:min-w-80 sm:max-w-96 h-full flex flex-col">
        <div className="flex-1 px-2 py-4 overflow-y-auto">
          <FavoritesListGrouped
            topicId={topicId}
            onClickCallback={onClickSkill}
          />
        </div>
      </div>
    </div>
  );
};

export default SkillsTab;
